import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Fix: Prevent "removeChild" / "insertBefore" crashes caused by browser extensions
// (Google Translate, Grammarly, LastPass, etc.) that modify React-managed DOM nodes.
// This is a known React issue: https://github.com/facebook/react/issues/11538
if (typeof Node !== 'undefined') {
  const origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child.parentNode !== this) {
      console.warn('Prevented removeChild crash (browser extension conflict)');
      return child;
    }
    return origRemoveChild.call(this, child);
  };

  const origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function(newNode, refNode) {
    if (refNode && refNode.parentNode !== this) {
      console.warn('Prevented insertBefore crash (browser extension conflict)');
      return newNode;
    }
    return origInsertBefore.call(this, newNode, refNode);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
// StrictMode disabled to prevent double-render issues with Radix UI
root.render(<App />);
